export default "__VITE_ASSET__7c648228__"